// Module-level singleton for the per-element source node. Lives in its own
// file (separate from playbackAtoms.ts) so primaryAtoms can disconnect it
// from resetAudioPlayerAtom without a circular import.
let mediaElementSource: MediaElementAudioSourceNode | null = null;
// MediaElementAudioSourceNode is permanently bound to the HTMLAudioElement it
// was created with. If the element is replaced (e.g. non-Safari swap from a
// programmatic Audio() to a DOM <audio> ref), the old source must be
// disconnected and a new one created — otherwise audio bypasses the gain node.
let boundElement: HTMLAudioElement | null = null;

export const getMediaElementSource = () => mediaElementSource;

export const getBoundAudioElement = () => boundElement;

export const setMediaElementSource = (
  node: MediaElementAudioSourceNode | null,
  element: HTMLAudioElement | null = null
) => {
  mediaElementSource = node;
  boundElement = element;
};
